const API_URL = `${process.env.ZMS_API !== undefined ? process.env.ZMS_API : ''}/api/visitor/`;

const add = async (props) => {
	const acceptableProps = ['googleID', 'permitted', 'audiences', 'sessions'];
	const data = Object.assign({}, props);
	for (let key in data) {
		if (acceptableProps.indexOf(key) === -1)delete data[key];
	}
	let result;
	try {
		result = await fetch(`${API_URL}add/`, {
			body: JSON.stringify(data),
			headers: {
				'content-type': 'application/json',
			},
			method: 'POST',
		});
		return await result.json();
	}
	catch (err) {
		console.log(err);
	}
}

let updateBody;
let timerID;
const update = async (props) => {
	const acceptableProps = ['id', 'googleID', 'permitted', 'audiences', 'sessions'];
	const data = Object.assign({}, props);
	for (let key in data) {
		if (acceptableProps.indexOf(key) === -1)delete data[key];
	}
	if (timerID)clearTimeout(timerID);
	updateBody = JSON.stringify(data);
	timerID = setTimeout(commit, 1000);
}

const commit = () => {
	if (timerID)clearTimeout(timerID);
	timerID = null;
	let commitBody = updateBody;
	updateBody = null;
	if (commitBody) {
		fetch(`${API_URL}update/`, {
			body: commitBody,
			headers: {
				'content-type': 'application/json',
			},
			method: 'POST',
		}).then(() => commitBody = null);
	}
}

const Visitor = {
	add,
	update,
	commit,
}
export default Visitor;